export const SupportTypes = {
    BENEFICIARY: "BENEFICIAIRE",
    CUSTOMER: "FINANCEUR",
}
